<template>
  <div @keydown.esc="hideContent()" ref="dropdown" class="relative">
    <div @click="toggle()">
      <slot v-bind:contentVisible="contentVisible"></slot>
    </div>
    <div
      ref="dropdownContent"
      @blur="hideContent()"
      class="content absolute right-0 mt-2"
      v-show="contentVisible"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentVisible: false,
    };
  },
  methods: {
    toggle() {
      this.contentVisible = !this.contentVisible;
    },
    handleBodyClick(event) {
      if (this.$refs.dropdown == event.target || this.$refs.dropdown.contains(event.target)) {
        return;
      }
      this.contentVisible = false;
    },
    hideContent() {
      this.contentVisible = false;
    },
  },
  mounted() {
    document.body.addEventListener('click', this.handleBodyClick);
    this.$refs.dropdownContent.addEventListener('focusout', this.hideContent);
  },
  unmounted() {
    document.body.removeEventListener('click', this.handleBodyClick);
  },
};
</script>

<style lang="scss" scoped>
.content {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08) !important;
}
</style>
